// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
// apiKey: "AIzaSyCeZkQ8Cd3wuYDHmg60aq2wt8A8swlsJXA",
//   authDomain: "wularwaterfront--web.firebaseapp.com",
//   projectId: "wularwaterfront--web",
//   storageBucket: "wularwaterfront--web.firebasestorage.app",
//   messagingSenderId: "656623560173",
//   appId: "1:656623560173:web:6a4f9f97de9d1889c7b3e4",
//   measurementId: "G-8XL9D0E3NP"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAkUZY5Fsx6iBduFkDYjI-1COVLfle2AGg",
  authDomain: "hotel-lakeview.firebaseapp.com",
  projectId: "hotel-lakeview",
  storageBucket: "hotel-lakeview.firebasestorage.app",
  messagingSenderId: "280501531254",
  appId: "1:280501531254:web:4559d2e0f9960175b42557",
  measurementId: "G-KZHCL52DBF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
